import React, { Fragment } from 'react';
import type { FC } from 'react';

import {
	LoadableAfterPaint,
	LoadableActivatable,
	ActivationTriggerType,
} from '@confluence/loadable';
import { expVal } from '@confluence/feature-experiments';

import type { EndOfPageRecommendationProps } from './EndOfPageRecommendation';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess';

export const EndOfPageRecommendationLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation'
			)
		).EndOfPageRecommendation,
});

export const EndOfPageRecommendationLoaderWithScrollIntoView = LoadableActivatable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation'
			)
		).EndOfPageRecommendation,
	triggers: [
		{
			type: ActivationTriggerType.SCROLL_INTO_VIEW,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.EndOfPageRecommendation,
});

export const EndOfPageRecommendationFinalLoader: FC<EndOfPageRecommendationProps> = (props) => {
	return (
		<Fragment>
			{expVal('confluence_selective_hydrate_eop_recommendations', 'isEnabled', false) ? (
				<EndOfPageRecommendationLoaderWithScrollIntoView {...props} />
			) : (
				<EndOfPageRecommendationLoader {...props} />
			)}
		</Fragment>
	);
};
